

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class CardBasic extends Vue {
  @Prop({
    required: false,
    default: false,
  })
  private fullHeight!: boolean;
}
